/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyImport } from './routes/verify'
import { Route as SignupImport } from './routes/signup'
import { Route as LoginImport } from './routes/login'
import { Route as FeedbackImport } from './routes/feedback'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AuthNavbarImport } from './routes/_auth._navbar'
import { Route as AuthNavbarHomeImport } from './routes/_auth._navbar.home'

// Create/Update Routes

const VerifyRoute = VerifyImport.update({
  path: '/verify',
  getParentRoute: () => rootRoute,
} as any)

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const FeedbackRoute = FeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthNavbarRoute = AuthNavbarImport.update({
  id: '/_navbar',
  getParentRoute: () => AuthRoute,
} as any)

const AuthNavbarHomeRoute = AuthNavbarHomeImport.update({
  path: '/home',
  getParentRoute: () => AuthNavbarRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_navbar': {
      id: '/_auth/_navbar'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthNavbarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_navbar/home': {
      id: '/_auth/_navbar/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthNavbarHomeImport
      parentRoute: typeof AuthNavbarImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthRoute: AuthRoute.addChildren({
    AuthNavbarRoute: AuthNavbarRoute.addChildren({ AuthNavbarHomeRoute }),
  }),
  FeedbackRoute,
  LoginRoute,
  SignupRoute,
  VerifyRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/feedback",
        "/login",
        "/signup",
        "/verify"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_navbar"
      ]
    },
    "/feedback": {
      "filePath": "feedback.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/verify": {
      "filePath": "verify.tsx"
    },
    "/_auth/_navbar": {
      "filePath": "_auth._navbar.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_navbar/home"
      ]
    },
    "/_auth/_navbar/home": {
      "filePath": "_auth._navbar.home.tsx",
      "parent": "/_auth/_navbar"
    }
  }
}
ROUTE_MANIFEST_END */
